/**
 * Builds a UI component that represents a particular EntitySet
 * and understands how to fetch the EntitySet if it has not yet
 * been fetched and how to re-render itself whenever the contents
 * of the set change.
 *
 * The Component widget is largely used to render pieces of the LHS
 * (e.g., refpanel/allergies.js) and in ComponentDialogs
 * (e.g., viewLabOrderSets.js)
 */

goog.provide('el8.uiwidget.Component');

el8.uiwidget.Component = function(spec) {

    spec = spec || {};

    this._dataRenderers = spec.dataRenderers || [];
    this._initFn = spec.initFn || null;
    this._showFn = spec.showFn || null;
    this._loadFn = spec.loadFn || null;
};

el8.uiwidget.Component.prototype._init = function() {

    if (this._isInit) { return; }
    if (this._initFn) { this._initFn(); }

    var that = this;

    // Assign all the observers
    for (var i=0; i<this._dataRenderers.length; i++) {
        var set = this._dataRenderers[i].entitySet;

        var rendInitFn = this._dataRenderers[i].initFn;
        if (rendInitFn) { rendInitFn(); }

        var listenFn = this._dataRenderers[i].listenFn;
        if (listenFn && set) { set.addObserver(listenFn); }

        var itemListenFn = this._dataRenderers[i].itemListenFn;
        if (itemListenFn && set) { set.addItemObserver(itemListenFn); }

        var events = this._dataRenderers[i].events;
        var renderFn = this._dataRenderers[i].renderFn;
        if (events && set) {
            events.map(function(obj) { set.bind(obj['eventName'], obj['fn'] || renderFn); });
        }
    }

    this._isInit = true;
};

el8.uiwidget.Component.prototype.show = function(doLoad) {
    if (!this._isInit) { this._init(); }
    if (this._showFn) { this._showFn(); }
    this.render(doLoad);
};

el8.uiwidget.Component.prototype.render = function(doLoad) {

    var that = this;

    var doListen = function() {
        for (var i=0; i<that._dataRenderers.length; i++) {
            var set = that._dataRenderers[i].entitySet;
            var listenFn = that._dataRenderers[i].listenFn;
            var preRenderFn = that._dataRenderers[i].preRenderFn;
            var renderFn = that._dataRenderers[i].renderFn;
            if (preRenderFn) { preRenderFn(); }
            if (listenFn) { listenFn(); }
            if (renderFn) { renderFn(); }
        }
    };

    var doLoadAndListen = function() {
        for (var i=0; i<that._dataRenderers.length; i++) {
            var set = that._dataRenderers[i].entitySet;
            var listenFn = that._dataRenderers[i].listenFn;
            var preRenderFn = that._dataRenderers[i].preRenderFn;
            var renderFn = that._dataRenderers[i].renderFn;
            if (preRenderFn) { preRenderFn(); }
            if (listenFn && set) {
                set.load(listenFn, true); // async load
            } else if (renderFn && set) {
                set.load(null, true); // async load
            }
        }
    };

    if (doLoad === true) {
        if (!this._loadFn) {
            doLoadAndListen();
        } else {
            this._loadFn(doListen);
        }
    } else {
        doListen();
    }

};
